export { default as SimilarAdCard } from './SimilarAdCard';



// WEBPACK FOOTER //
// ./src/components/SimilarAdCard/index.ts